import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectEamEfaDashboardUrls } from 'selectors/eamEfaDashboardSelector';
import { cardStyle } from 'views/OrderNewProductOrService/OrderNewProductOrService';
import CardBodyComponent from '../common/card/CardBodyComponent';
import CardHeaderComponent from '../common/card/CardHeaderComponent';
import CardTooltipButton from '../common/card/CardTooltipButton';
import { Features } from 'reducers/partnerStatusReducer';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';

import { selectIsEligible } from 'selectors/partnerStatusSelector';

interface EamEfaDashboardProps {
  partnerId?: string;
}

const EamEfaDashboard: React.FC<EamEfaDashboardProps> = () => {
  const {
    info: { url },
  } = useSelector(selectEamEfaDashboardUrls);
  const isEligibleForDashboardStore = useSelector(selectIsEligible) as
    | (FeatureEligibility[] & { message?: string; messages?: string[] })
    | undefined;

  const onCreateEamEfaDashboardClick = () => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  const isEligibleForDashboard = useMemo<FeatureEligibility | undefined>(() => {
    if (isEligibleForDashboardStore?.message) return undefined;
    return (
      isEligibleForDashboardStore?.find((eligibility) => eligibility.feature === Features.EAM_EFA_DASHBOARD) ??
      undefined
    );
  }, [isEligibleForDashboardStore]);

  const title = useMemo<React.ReactNode>(() => {
    if (isEligibleForDashboardStore?.messages) {
      return isEligibleForDashboardStore.messages[0];
    }
    return 'Partner is not eligible for the EAM / EFA Subscription Dashboard';
  }, [isEligibleForDashboardStore]);

  return (
    <Grid data-testid="eam-efa-dashboard" item sx={cardStyle}>
      <CardHeaderComponent title={'EAM / EFA Subscription Dashboard'} />
      <CardBodyComponent content={'Open the EAM / EFA Subscription Dashboard.'} />
      <CardTooltipButton
        id={'eam-efa-dashboard-button-create'}
        data-testid={'eam-efa-dashboard-create'}
        buttonText={'Open subscription dashboard'}
        isEligible={isEligibleForDashboard?.isEligible ?? false}
        handleClick={onCreateEamEfaDashboardClick}
        tooltipTitle={title}
      />
    </Grid>
  );
};

export default EamEfaDashboard;
